import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'findByProperty',
})
export class FindByPropertyPipe implements PipeTransform {
  transform(list: any[] = [], property: string, value: string | number): any {
    if (!property || value == null) {
      return null;
    }

    return list.find((x) => x[property] === value);
  }
}
